var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6802 4.17701L15.5076 7.82776C15.6867 8.18616 16.0324 8.43467 16.4333 8.49218L20.5213 9.08062C21.5313 9.22644 21.9332 10.4505 21.2022 11.1519L18.2461 13.9924C17.9556 14.2718 17.8234 14.6733 17.8921 15.0676L18.5897 19.0778C18.7615 20.0698 17.7057 20.8267 16.8029 20.3574L13.1491 18.4627C12.7909 18.2768 12.3619 18.2768 12.0027 18.4627L8.34893 20.3574C7.44616 20.8267 6.39032 20.0698 6.56317 19.0778L7.25977 15.0676C7.3285 14.6733 7.19626 14.2718 6.90575 13.9924L3.94961 11.1519C3.21864 10.4505 3.62057 9.22644 4.63059 9.08062L8.71858 8.49218C9.11946 8.43467 9.4662 8.18616 9.6453 7.82776L11.4717 4.17701C11.9236 3.27433 13.2283 3.27433 13.6802 4.17701Z",
    fill: "#F198FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.4a6298a2.svg";
export { ForwardRef as ReactComponent };